<template>
  <div>
    <table
      class="table"
      v-if="scrapperList.length != 0"
      style="table-layout: fixed"
    >
      <thead style="position: sticky;">
        <tr>
          <th style="text-align: center; width: 3%">
            <input v-model="actionSelectionControl" type="checkbox" />
          </th>
          <th style="width: 12%">ASIN</th>
          <th>Brand Code</th>
          <th class="link" v-on:click="sorting('brand', $event)">
            Brand
            <i
              class="sort fa"
              :class="
                sort.field == 'brand'
                  ? sort.order == 'asc'
                    ? 'fa-arrow-up'
                    : 'fa-arrow-down'
                  : ''
              "
            ></i>
          </th>
          <th class="link" v-on:click="sorting('vendor_name', $event)">
            Vendor Name
            <i
              class="sort fa"
              :class="
                sort.field == 'vendor_name'
                  ? sort.order == 'asc'
                    ? 'fa-arrow-up'
                    : 'fa-arrow-down'
                  : ''
              "
            ></i>
          </th>
          <th style="width: 20%;">Title</th>
          <th>Country Code</th>
          <th class="link" v-on:click="sorting('created_on', $event)">
            Created On
            <i
              class="sort fa"
              :class="
                sort.field == 'created_on'
                  ? sort.order == 'asc'
                    ? 'fa-arrow-up'
                    : 'fa-arrow-down'
                  : ''
              "
            ></i>
          </th>
          <th class="link" v-on:click="sorting('updated_on', $event)">
            Last Updated On
            <i
              class="sort fa"
              :class="
                sort.field == 'updated_on'
                  ? sort.order == 'asc'
                    ? 'fa-arrow-up'
                    : 'fa-arrow-down'
                  : ''
              "
            ></i>
          </th>
          <th>Resp Contact</th>
          <th>View on Amazon</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item,index) in scrapperList" :key="item.asin" :class="index%2==0?'even':''">
          <td style="text-align: center">
            <input
              v-model="item.isSelected"
              @change="addProductToSelected(item)"
              type="checkbox"
            />
          </td>
          <td>{{ item.asin }}</td>
          <td>{{ item.brand_code }}</td>
          <td>{{ item.brand }}</td>
          <td>{{ item.vendor_name }}</td>
          <td width="30%">{{ item.product_title }}</td>
          <td>{{ item.country_code }}</td>
          <td>
            {{ item.created_on ? getFormattedDate(item.created_on) : "" }}
          </td>
          <td>
            {{ item.updated_on ? getFormattedDate(item.updated_on) : "" }}
          </td>
          <td>{{ item.respContact }}</td>
          <td>
            <a
              :href="item.pdp_url"
              target="_blank"
              style="color: #143a33"
              >Amazon Profile</a
            >
          </td>
          <td class="row-add-edit">
            <div class="row-add-edit" id="asinScrapper-list-drop-down">
              <a
                href="javascript:void(0)"
                class="item-add-edit"
                data-toggle="dropdown"
              ></a>
              <div
                class="dropdown-menu "
                aria-labelledby="dropdownMenuButton"
                style="left: -58px"
              >
                <a
                  class="grid-item ico-activity"
                  href="javascript:void(0)"
                  @click="AddGuardrail(item)"
                  >Create Guardrail</a
                >
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- <NoDataAvailable v-else displayMessage="No Data is Available"></NoDataAvailable> -->
  </div>
</template>

<script>
import AsinScraperListGridFooter from "@/components/asin-scraper/AsinScraperListGridFooter";
import NoDataAvailable from "../NoDataAvailable.vue";
import moment from "moment";

export default {
  name: "AsinScraperListGrid",
  data() {
    return {};
  },
  components: {
    AsinScraperListGridFooter,
    NoDataAvailable,
    moment,
  },
  computed: {
    scrapperList: {
      set(val) {
        this.$store.state.asinScapper.scrapperList = val;
      },
      get() {
        return this.$store.state.asinScapper.scrapperList;
      },
    },
    selectedProducts: {
      set(val) {
        this.$store.state.product.selectedProducts = val;
      },
      get() {
        return this.$store.state.product.selectedProducts;
      },
    },
    actionSelectionControl: {
      set(val) {
        this.$store.state.product.actionSelectionControl = val;
        if (val) {
          this.selectAllProduct();
        } else {
          this.resetSelectAllProduct();
        }
      },
      get() {
        return this.$store.state.product.actionSelectionControl;
      },
    },
    sort: {
      set(val) {
        this.$store.commit("setSelectedSortOrder", val);
      },
      get() {
        return this.$store.state.selectedSortOrder;
      },
    },
  },
  methods: {
    addProductToSelected(item) {
      if (item.isSelected) {
        this.selectedProducts.push(JSON.parse(JSON.stringify(item)));
        console.log(this.selectedProducts);
      } else {
        this.removeProductFromSelected(item);
      }
    },
    getFormattedDate(data) {
      return moment(data).format("MM/DD/YYYY");
    },
    removeProductFromSelected(item) {
      let index = this.selectedProducts.findIndex((element) => {
        return element.asin == item.asin;
      });
      this.selectedProducts.splice(index, 1);
      console.log(this.selectedProducts);
      this.$store.state.product.actionSelectionControl = false;
    },
    selectAllProduct() {
      this.scrapperList.forEach((element) => {
        element.isSelected = true;
      });
      this.selectedProducts = JSON.parse(JSON.stringify(this.scrapperList));
    },
    resetSelectAllProduct() {
      this.scrapperList.forEach((element) => {
        element.isSelected = false;
      });
      this.selectedProducts = [];
    },
    AddGuardrail(item) {
      this.openGuardrail(item)
    },
    openGuardrail(item){
      this.selectedProducts = [];
      this.actionSelectionControl = false;
      this.selectedProducts.push(item);
      this.$router.push({
        path: '/addEditGuardrail/' + 'null' + '/myAutomation' + '/asin'
      });
    },
    sorting(field, event) {
      this.$store.state.product.actionSelectionControl = false;
      this.$store.state.product.selectedProducts = [];
      if (
        event.currentTarget.children[0].classList[2] == "fa-arrow-up" ||
        event.currentTarget.children[0].classList[2] == "fa-arrow-down"
      ) {
        var pastEvent = true;
      }
      for (var i = 0; i < document.getElementsByClassName("sort").length; i++) {
        document
          .getElementsByClassName("sort")
          [i].classList.remove("fa-arrow-up");
        document
          .getElementsByClassName("sort")
          [i].classList.remove("fa-arrow-down");
      }
      if (pastEvent) {
        this.sort.order == "desc"
          ? event.currentTarget.children[0].classList.add("fa-arrow-up")
          : event.currentTarget.children[0].classList.add("fa-arrow-down");
        pastEvent = false;
      } else {
        event.currentTarget.children[0].classList.add("fa-arrow-up");
      }

      this.sort = {
        field: field,
        order:
          event.currentTarget.children[0].classList[2] == "fa-arrow-up"
            ? "asc"
            : "desc",
      };
    },
  },
};
</script>

<style lang="scss">
.hightlight {
  background-color: #3da3a7 !important;
  color: #fff !important;
}
</style>
